import { render, staticRenderFns } from "./DashboardMarketBanner.html?vue&type=template&id=af82d1de&scoped=true&"
import script from "./DashboardMarketBanner.js?vue&type=script&lang=js&"
export * from "./DashboardMarketBanner.js?vue&type=script&lang=js&"
import style0 from "./DashboardMarketBanner.scss?vue&type=style&index=0&id=af82d1de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af82d1de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VRow,VSkeletonLoader})
